// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBBtn } from 'mdbreact';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

const ControlButtonsSection = ({
  closeModal,
  submit,
}) => {
  const cancel = (event) => {
    event.preventDefault();
    closeModal();
  };

  const handlerSave = async event => {
    event.preventDefault();
    submit('contractorTaxInformationReduxForm');
  };

  return (
    <div className="field_row">
      <button
        color="success"
        className="standard_btn light_btn"
        type="button"
        name="save"
        onClick={handlerSave}
      >
        Save Tax Information
      </button>
      <button
        className="standard_btn light_btn"
        type="button"
        onClick={cancel}
      >
        Cancel
      </button>
    </div>
  );
};

const mapDispatchToProps = {
  submit,
};

export default connect(null, mapDispatchToProps)(ControlButtonsSection);
